import type { MarketplaceResponse } from '@/types/api';
import { subscriptionPurchaseIdentity } from './subscriptionOwnership';

/** Remove newly purchased products from a cached marketplace response before
 * the ownership refetch finishes. This prevents Home from briefly rendering
 * a pre-purchase recommendation after the intake wizard returns to `/app`. */
export function marketplaceAfterPurchase(
  marketplace: MarketplaceResponse,
  canonicalProductIds: Iterable<string>,
): MarketplaceResponse {
  const purchased = new Set([...canonicalProductIds].map(subscriptionPurchaseIdentity));
  const removedProductIds = new Set(
    marketplace.products
      .filter(
        (product) =>
          product.canonical_product_id != null &&
          purchased.has(subscriptionPurchaseIdentity(product.canonical_product_id)),
      )
      .map((product) => product.id),
  );

  return {
    ...marketplace,
    products: marketplace.products.filter(
      (product) =>
        product.canonical_product_id == null ||
        !purchased.has(subscriptionPurchaseIdentity(product.canonical_product_id)),
    ),
    recommendations: (marketplace.recommendations ?? []).filter(
      (recommendation) =>
        !purchased.has(subscriptionPurchaseIdentity(recommendation.canonical_product_id)) &&
        !removedProductIds.has(recommendation.product_id),
    ),
  };
}
